export default "__VITE_ASSET__B4plG564__"